module.exports = __webpack_public_path__ + "img/c.c3a154b3.png";